module.exports = new __parcel__URL__("camel.6111d481.svg").toString();